import { render, staticRenderFns } from "./GlassBreakageDamageTypeQuestion.vue?vue&type=template&id=fbfebd0c&scoped=true"
import script from "./GlassBreakageDamageTypeQuestion.vue?vue&type=script&lang=ts"
export * from "./GlassBreakageDamageTypeQuestion.vue?vue&type=script&lang=ts"
import style0 from "./GlassBreakageDamageTypeQuestion.vue?vue&type=style&index=0&id=fbfebd0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfebd0c",
  null
  
)

export default component.exports